import sendGroupMessageApi from './sendGroupMessageApi';
import sendPrivateMessageApi from './sendPrivateMessageApi';
import sendGroupForwardMessageApi from './sendGroupForwardMessageApi';
import sendMessageApi from './sendMessageApi';
import getMessageApi from './getMessageApi';
import getImageApi from './getImageApi';
import GetForwardMessageApi from './getForwardMessageApi';
import deleteMessageApi from './deleteMessageApi';
import markMessageAsReadApi from './markMessageAsReadApi';
import sendGroupSignApi from './sendGroupSignApi';
import setGroupAddRequestApi from './setGroupAddRequestApi';
import setGroupAdminApi from './setGroupAdminApi';
import setGroupAnonymousApi from './setGroupAnonymousApi';
import setGroupAnonymousBanApi from './setGroupAnonymousBanApi';
import setGroupBanApi from './setGroupBanApi';
import setGroupCardApi from './setGroupCardApi';
import setGroupLeaveApi from './setGroupLeaveApi';
import setGroupNameApi from './setGroupNameApi';
import setGroupSpecialTitleApi from './setGroupSpecialTitleApi';
import setGroupWholeBanApi from './setGroupWholeBanApi';
import setFriendAddRequestApi from './setFriendAddRequestApi';
import getLoginInfoApi from './getLoginInfoApi';
import canSendImageApi from './canSendImageApi';
import canSendRecordApi from './canSendRecordApi';
import checkUrlSafelyApi from './checkUrlSafelyApi';
import cleanCacheApiExpect from './cleanCacheApiExpect';
import createGroupFileFolderApi from './createGroupFileFolderApi';
import deleteEssenceMsgApi from './deleteEssenceMsgApi';
import deleteFriendApi from './deleteFriendApi';
import deleteGroupFileApi from './deleteGroupFileApi';
import deleteGroupFolderApi from './deleteGroupFolderApi';
import downloadFileApi from './downloadFileApi';
import getCookiesApiExpect from './getCookiesApiExpect';
import getCredentialsApiExpect from './getCredentialsApiExpect';
import getCSRFTokenApiExpect from './getCSRFTokenApiExpect';
import getEssenceMsgListApi from './getEssenceMsgListApi';
import getFriendListApi from './getFriendListApi';
import getGroupAtAllRemainApi from './getGroupAtAllRemainApi';
import getGroupFilesByFolderApi from './getGroupFilesByFolderApi';
import getGroupFileUrlApi from './getGroupFileUrlApi';
import getGroupHonorInfoApi from './getGroupHonorInfoApi';
import getGroupInfoApi from './getGroupInfoApi';
import getGroupListApi from './getGroupListApi';
import getGroupMemberListApi from './getGroupMemberListApi';
import getGroupMessageHistoryApi from './getGroupMessageHistoryApi';
import getGroupNoticeApi from './getGroupNoticeApi';
import getGroupRootFilesApi from './getGroupRootFilesApi';
import getGroupSystemMsgApi from './getGroupSystemMsgApi';
import getGroupFileSystemInfoApi from './getGroupFileSystemInfoApi';
import getModelShowApi from './getModelShowApi';
import getOnlineClientsApi from './getOnlineClientsApi';
import getRecordApiExpect from './getRecordApiExpect';
import getStatusApi from './getStatusApi';
import getStrangerInfoApi from './getStrangerInfoApi';
import getUnidirectionalFriendListApi from './getUnidirectionalFriendListApi';
import getVersionInfoApi from './getVersionInfoApi';
import ocrImageApi from './ocrImageApi';
import reloadEventFilterApi from './reloadEventFilterApi';
import sendGroupNoticeApi from './sendGroupNoticeApi';
import setEssenceMsgApi from './setEssenceMsgApi';
import setGroupPortraitApi from './setGroupPortraitApi';
import setModelShowApi from './setModelShowApi';
import setQQProfileApi from './setQQProfileApi';
import setRestartApi from './setRestartApi';
import uploadGroupFileApi from './uploadGroupFileApi';
import uploadPrivateFileApi from './uploadPrivateFileApi';

export const CqApi = {
	canSendImageApi,
	canSendRecordApi,
	checkUrlSafelyApi,
	cleanCacheApiExpect,
	createGroupFileFolderApi,
	deleteEssenceMsgApi,
	deleteFriendApi,
	deleteGroupFileApi,
	deleteGroupFolderApi,
	deleteMessageApi,
	downloadFileApi,
	getCookiesApiExpect,
	getCredentialsApiExpect,
	getCSRFTokenApiExpect,
	getEssenceMsgListApi,
	GetForwardMessageApi,
	getFriendListApi,
	getGroupAtAllRemainApi,
	getGroupFileSystemInfoApi,
	getGroupFilesByFolderApi,
	getGroupFileUrlApi,
	getGroupHonorInfoApi,
	getGroupInfoApi,
	getGroupListApi,
	getGroupMemberListApi,
	getGroupMessageHistoryApi,
	getGroupNoticeApi,
	getGroupRootFilesApi,
	getGroupSystemMsgApi,
	getImageApi,
	getLoginInfoApi,
	getMessageApi,
	getModelShowApi,
	getOnlineClientsApi,
	getRecordApiExpect,
	getStatusApi,
	getStrangerInfoApi,
	getUnidirectionalFriendListApi,
	getVersionInfoApi,
	markMessageAsReadApi,
	ocrImageApi,
	reloadEventFilterApi,
	sendGroupForwardMessageApi,
	sendGroupMessageApi,
	sendGroupNoticeApi,
	sendGroupSignApi,
	sendMessageApi,
	sendPrivateMessageApi,
	setEssenceMsgApi,
	setFriendAddRequestApi,
	setGroupAddRequestApi,
	setGroupAdminApi,
	setGroupAnonymousApi,
	setGroupAnonymousBanApi,
	setGroupBanApi,
	setGroupCardApi,
	setGroupLeaveApi,
	setGroupNameApi,
	setGroupPortraitApi,
	setGroupSpecialTitleApi,
	setGroupWholeBanApi,
	setModelShowApi,
	setQQProfileApi,
	setRestartApi,
	uploadGroupFileApi,
	uploadPrivateFileApi,
};
